//import React from 'react';
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import styled, { createGlobalStyle } from "styled-components";
import { processDomainDataLists, getDateStringFromWeek } from './DealsDataHelper';
//import { getDealSpecials } from "../../actions/dealsActions";



// import { bindActionCreators } from "redux";

// import { performThumbnailSearch } from "../../actions/thumbnailActions";

import TextFieldGroup from "../common/TextFieldGroup";
import SelectCategoryGroup from "../common/SelectCategoryGroup";
import DoubleSlider from "./DoubleSlider";
import DateSlider from "./DateSlider";

import Modal from "react-responsive-modal";

const span = styled("div")`
  display: inline-block;
  height: 12px;
  width: 90%;
  margin: 0 5%;
  color:white;
  font-size:10pt;
`;

class QueryDealsBar extends Component {
  constructor(props) {
    super(props);
    //  console.log("passed in props", props.minmax);

    this.state = {

      searchterm: "",
      // startdate: new Date(),

      minmax: props.mimmax,
      semillis: props.semillis,
      minppn: 0,
      maxppn: 0,
      minlok: 0,
      maxlok: 0,
      startci: 0,
      endci: 4,

      weeks_cb: true,
      lok_cb: false,
      wildcard_cb: false,
      ppn_cb: true,
      errors: {}
    };

    this.onChange = this.onChange.bind(this);
    this.onCBChange = this.onCBChange.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);

  }
  /*
    static getDerivedStateFromProps(props, state) {
      // Any time the current user changes,
      // Reset any parts of state that are tied to that user.
      // In this simple example, that's just the email.
      if (props.userID !== state.prevPropsUserID) {
        return {
          prevPropsUserID: props.userID,
          email: props.defaultEmail
        };
      }
      return null;
    }
  
  */


  componentDidMount() {

    //console.log('qdb mounted');


  }

  /*
    componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
      if (this.props.userID !== prevProps.userID) {
      }
    }
  */
  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  onCBChange(e) {
    let ischecked = true;
    if (e.target.value === 'on') ischecked = false;
    // this.setState({ [e.target.name]: ischecked });

    // this.setState({ [e.target.name]: e.target.value });
  }

  submitFormData(e) {
    e.preventDefault();
    this.submitQueryData();
  }

  submitQueryData() {
    let sobj = {};
    let weeks_cb = document.getElementById('weeks_cb').checked;
    let lok_cb = document.getElementById('lok_cb').checked;
    let wildcard_cb = document.getElementById('wildcard_cb').checked;
    let ppn_cb = document.getElementById('ppn_cb').checked;

    // sobj['bedrooms'] = this.state.bedrooms;
    //  sobj['city'] = this.state.city;
    //  sobj['state'] = this.state.state;
    //   sobj['startdate'] = this.state.startdate;
    sobj['searchterm'] = this.state.searchterm;
    sobj['minppn'] = this.state.minppn;
    sobj['maxppn'] = this.state.maxppn;
    sobj['minlok'] = this.state.minlok;
    sobj['maxlok'] = this.state.maxlok;

    sobj['start_date'] = this.state.startci;
    sobj['end_date'] = this.state.endci;
    sobj['weeks_cb'] = weeks_cb;
    sobj['lok_cb'] = lok_cb;
    sobj['wildcard_cb'] = wildcard_cb;
    sobj['ppn_cb'] = ppn_cb;
    this.props.onQueryDealsSubmit(sobj);

  }


  handleKeyUp(e) {
    e.preventDefault();
    let cb = document.getElementById('wildcard_cb');
    let st = this.state.searchterm;
    if (st == "") {
      cb.checked = false;
    } else {
      cb.checked = true;
    }
  }

  ppnFromSlider = (minmax) => {
    // console.log('in filters bar plice ppnRangeFromSlider slider value', minmax);
    let cb = document.getElementById('ppn_cb');
    cb.checked = true;
    this.setState({ minppn: minmax[0], maxppn: minmax[1], ppn_cb: true });


  }
  lokFromSlider = (minmax) => {
    let cb = document.getElementById('lok_cb');
    if (this.state.lok_cb) {
      cb.checked = true;
    }
    this.setState({ minlok: minmax[0], maxlok: minmax[1], lok_cb: true });
    // this.getDomainData(what);
    // this.goToDeals(what);
  }

  valuesFromDateSlider = (valary) => {

    // console.log('we have vals from date slider', valary);
    let cb = document.getElementById('weeks_cb');
    cb.checked = true;


    let robj = getDateStringFromWeek(valary[0]);
    let stime = robj['millis'];
    let startci = robj['datestr'];

    let robj2 = getDateStringFromWeek(valary[1]);
    let etime = robj2['millis'];
    let endci = robj2['datestr'];

    // console.log('startci', startci, 'endci', endci);


    this.setState({ startci: startci, endci: endci, startmillis: stime, endmillis: etime, weeks_cb: true });

    //1544313600000
    // let testdate = new Date(1608163532451).toDateString();
    // console.log(testdate);

  }
  wildcardSearch = () => {

    this.submitQueryData()
  }


  processDealsSpecials = (e, which) => {
    e.preventDefault();
    let lbl = '';
    let qobj = {};
    if (which == 'lmd') {
      qobj['which'] = 'checkin';
    }
    if (which == 'ppn') {
      qobj['which'] = 'ppn';
    }
    this.props.onSpecialsSubmit(qobj);
  }

  //let link = `/api/business/find-business/${bizid}`;
  render() {
    const { errors } = this.state;

    // const { minmax } = this.props;
    // const { semillis } = this.props;


    let { startci } = this.state;
    let { endci } = this.state;
    let { weeks_cb } = this.state;
    let { lok_cb } = this.state;
    let { wildcard_cb } = this.state;
    let { ppn_cb } = this.state;


    let { min_ppn } = this.props.deals;
    let { max_ppn } = this.props.deals;
    let { min_lok } = this.props.deals;
    let { max_lok } = this.props.deals;
    let range_ppn = [min_ppn, max_ppn];
    let range_lok = [min_lok, max_lok];
    let mm_lok = [3, 10];
    let minmax = [50, 150];
    let weekrange = this.props.deals['available_weeks_range']; //[0, 56];
    let weekvalary = [0, 4];

    return (
      <div id="querybar" className="dashboardmajor"
        style={{
          width: "95%",
          paddingBottom: "10px",
          fontSize: "10pt"
        }}
      >



        <div className="flex-grid">
          <div className="col" style={{ flex: "3" }}>
            <div>
              <span style={{ marginRight: "30px" }}>{startci}</span>

              <span className="form-check-inline" style={{ textAlign: "center" }} >
                <input type="checkbox" className="form-check-input" name="weeks_cb" id="weeks_cb"
                  defaultChecked={weeks_cb}
                  onChange={this.onCBChange} />
              </span>
              <span>{"Week"}</span>&nbsp;
              <span style={{ marginLeft: "30px" }}>{endci}</span>
            </div>
            <div>
              <DateSlider ticklabelcolor="white" change={this.valuesFromDateSlider} valary={weekvalary} range={weekrange} />
            </div>
          </div>

          <div className="col" style={{ flex: "2" }}>
            <div className="form-check-inline" style={{ textAlign: "left" }} >
              <input type="checkbox" className="form-check-input" name="lok_cb" id="lok_cb"
                defaultChecked={lok_cb}
                onChange={this.onCBChange} />
            </div>
            <span>{"Length of stay"}</span>
            <div style={{ marginTop: "5px" }}>
              <DoubleSlider ticklabelcolor="white" change={this.lokFromSlider} valary={mm_lok} range={range_lok} />
            </div>
          </div>
          <div className="col" style={{ flex: "1" }}>
            <div className="form-check-inline" style={{ textAlign: "left" }} >
              <input type="checkbox" className="form-check-input" name="wildcard_cb" id="wildcard_cb"
                defaultChecked={wildcard_cb}
                onChange={this.onCBChange} /><span>Keyword</span>
            </div>
            <div style={{ marginTop: "5px" }}>



              <div className="form-input">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Keyword Search"
                  name="searchterm"
                  value={this.state.searchterm}
                  onChange={this.onChange}
                  onKeyUp={this.handleKeyUp}
                  error={errors.searchterm}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex-grid" style={{ margin: "10px 0" }}>
          <div className="col" style={{ flex: "3" }}>
            <div className="form-check-inline" style={{ textAlign: "left" }} >
              <input type="checkbox" className="form-check-input" name="ppn_cb" id="ppn_cb"
                defaultChecked={ppn_cb}
                onChange={this.onCBChange} />
            </div>
            <span>{"Price per night"}</span>
            <DoubleSlider ticklabelcolor="white" change={this.ppnFromSlider} valary={minmax} range={range_ppn} />
          </div>
          <div className="col" style={{ flex: "2" }}>
            <div style={{ textAlign: "center", paddingTop: "15px" }}>
              <a
                className="btn btn-sm btn-info"
                href="#"
                onClick={(e) => {
                  this.processDealsSpecials(e, 'lmd');
                }}
              >
                Last minute deals
            </a>
            &nbsp;
            <a
                className="btn btn-sm btn-info "
                href="#"
                onClick={(e) => {
                  this.processDealsSpecials(e, 'ppn');
                }}
              >
                Lowest price per night
            </a>
            </div>
          </div>
          <div className="col" style={{ flex: "1" }}>
            <div style={{ textAlign: "right", paddingTop: "15px" }}>
              <a
                className="btn btn-md btn-info"
                href="#"
                onClick={(e) => { this.submitFormData(e) }}
              >
                Submit
            </a>
            &nbsp;
            </div>
          </div>
        </div>

      </div>

    );
  }
}




//export default withRouter(Advertisements);
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  deals: state.deals,
  // mimereducer: state.mimereducer,
});

export default connect(mapStateToProps, {


})(withRouter(QueryDealsBar));

/*

  // onChange(e) {
            //   this.setState({ searchterm: e.target.value });
            // }
            onCat0Select(e, cat) {
            let cat0list = document.getElementsByClassName("cat0nav");
    window.scrollTo(0, 0);
    for (var i = 0; i < cat0list.length; {
            let el = cat0list[i];
      el.classList.remove("navpicked");
    }
    let which = e.target;
    which.classList.add("navpicked");

    e.preventDefault();
  }

  onCat1Select(e, cat1) {
            e.preventDefault();
    let fobj = { };
    fobj = {cat0: this.state.cat0, cat1: cat1 };
    // let catlist2 = list_helper.getCat2(cat1);
    // if (catlist2.length > 0) {
            //   this.setState({ cat1: cat1, cat2_list: catlist2 });
            // } else {
            //console.log("we have no cat2 list so we run ", fobj);
            //this.props.getCategoryMimes(fobj);
            // }
            //console.log(typelist2);
          }

  onCat1SelectMoreList(cat1) {
            // console.log("more list onCat1SelectMoreList ", cat1);
            // this.setState({ showmore: false });
            // this.props.getCat1Mimes(cat1);
          }

  onCat2Select(e, cat2) {
            e.preventDefault();
    let fobj = { };
    fobj = {cat0: this.state.cat0, cat1: this.state.cat1, cat2: cat2 };
    // console.log("select cat2", fobj);

    // this.props.getMimes(fobj);
  }

*/

/*

  oldprocessDomainData(dary) {
            // ddobj['query'] = { '_id': '$city' };
            // ddobj['query'] = { '_id': '$state' };
            // ddobj['query'] = { '_id': '$lok' };
            // ddobj['query'] = { '_id': '$ppn' };
            // ddobj['query'] = { '_id': '$start_date' };
            // ddobj['query'] = { '_id': '$bedrooms' };
            let tary = [];
    let cary = [];
    let sary = [];
    let lary = [];
    let pary = [];
    let sdary = [];
    let bary = [];
    tary = dary[0];
    tary.forEach(el => {
            cary.push(el['_id']);
    })
    tary = dary[1];
    tary.forEach(el => {
            sary.push(el['_id']);
    })
    tary = dary[2];
    tary.forEach(el => {
            lary.push(el['_id']);
    })
    tary = dary[3];
    tary.forEach(el => {
            pary.push(el['_id']);
    })
    tary = dary[5];
    tary.forEach(el => {
            bary.push(el['_id']);
    })

    // let cary = dary[0];
    // let sary = dary[1];
    //lary = dary[2];
    // pary = dary[3];
    sdary = dary[4];
    // bard = dary[5];

    this.setState({'city_list': cary, 'state_list': sary, 'lok_list': lary, 'ppn_list': pary, 'bedroom_list': bary });


  }
*/



// WEBPACK FOOTER //
// ./src/components/deals/QueryDealsBar.js